import Breadcrumb from '../atoms/Breadcrumb'
import Container from '../atoms/Container'
import Heading from '../atoms/Heading'
import Image from 'next/image'
import Text from '../atoms/Text'
import React from 'react'

function About() {

    const breadcrumbs = [
        {
            name: "Home",
            path: "/",
            isActive: false
        },
        {
            name: "About",
            path: "/about",
            isActive: false
        },
    ]

    const addressess = [
        {
            name: 'KashKounter Pte. Ltd.',
            address: 'KashKounter Pte. Ltd.68 Circular Road #02-01 Singapore 049422 UEN 202302080N'
        },
        {
            name: 'KashKounter Bangladesh',
            address: '387/5 Free School Street, Hatirpool, Dhaka, Bangladesh'
        }
    ]

    return (
        <div className='min-h-[calc(100vh-220px)] pb-10 relative'>
            <Image
                src='/images/about-bg.svg'
                layout='fill'
                objectFit='contain'
            />
            <div className='relative z-1'>
                <Container>
                    <Breadcrumb className="py-5" divider="primary" textSize={"text-sm"} data={breadcrumbs} />
                </Container>
                <Container type='type4' className='text-center'>
                    <Heading type="h2" className="text-center !text-3xl md:!text-4xl font-bold text-primary-900 mb-4">ABOUT US</Heading>
                    <Text>
                        KashKounter is a South-Asia focused rewards platform that pays shoppers for purchases & increases loyalty for brands. We work with local and international brands as affiliates and enable shoppers to save their hard earned money.
                    </Text>
                    <Heading type="h2" className="text-center !text-3xl md:!text-4xl font-bold text-primary-900 mb-4 mt-8 md:mt-14">OUR OFFICES</Heading>
                    <div className='grid md:grid-cols-2 gap-4 max-w-[540px] mx-auto'>
                        {
                            addressess.map((address, index) => {
                                return (
                                    <div key={index} className='bg-white border border-neural-300 p-4 rounded-md text-left'>
                                        <div className='flex items-center gap-2 mb-4'>
                                            <Image
                                                src='/images/location.svg'
                                                width={32}
                                                height={32}
                                            />
                                            <Heading type="h6" className="text-sm font-semibold">{address.name}</Heading>
                                        </div>
                                        <Text variant='caption' className='leading-[18px]'>{address.address}</Text>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <Heading type="h2" className="text-center !text-3xl md:!text-4xl font-bold text-primary-900 mb-4 mt-8 md:mt-14">
                        CONTACT US
                    </Heading>
                    <div className='flex items-center justify-center gap-2 mb-4'>
                        <Image
                            src='/images/email.svg'
                            width={24}
                            height={24}
                        />
                        <Text>contact@kashkounter.com</Text>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default About